import * as R from 'ramda';
import { Store } from '../types';

export const sortByStoreAsc = R.sortBy(R.prop('store'));
export const sortByStoreDesc = R.sort(R.descend<Store>(R.prop('store')));

export const sortByNumberAsc = R.sortBy(R.prop('store_api_uuid'));
export const sortByNumberDesc = R.sort(R.descend<Store>(R.prop('store_api_uuid')));

export const sortByExtNameAsc = R.sortBy(R.prop('name'));
